import { Navigate } from "react-router-dom";
import LandingPage from "./LandingPage";
import { isMobileUserAgent } from "../lib/mobile/userAgent";

/** Landing desktop ; sur mobile, envoi vers l’app mobile (auth gérée par MobileProtectedRoute). */
export default function MobileAwareLanding() {
  if (isMobileUserAgent()) {
    return <Navigate to="/mobile/dashboard" replace />;
  }
  return <LandingPage />;
}
